// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add Routine to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
  section_basics:"Basics",
  section_essentials:"Essentials",
  section_works:"Works"
}

// Add default image url here
const tangent_default_selfie_image_url="https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/573948076890054-Rectangle%2040783.png";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  let tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    const tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    setTabOpen(response.tags);
    setConcernLists(response.tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData();        
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          
          const variant = getSelectedVariant(product, selected_variants[product.id]);
          const variantId = extractShopifyNumericId(variant.id);
          // Track selected product variant
          tangent_selected_product_map[product.id] = variantId;
          
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections,variantId);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = product_html;

          // Append the created product HTML to the fragment
          while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function extractShopifyNumericId(gid) {
  if (typeof gid !== 'string') return null;

  const match = gid.match(/\d+$/);
  return match ? match[0] : null;
}

function setConcernLists(tags){
  // Hair concerns
  const hairConcern = tags
    .filter(str => str.includes("hair_concern"))
    .map(str =>
      str
        .replace("secondary_hair_concern_", "")
        .replace("hair_concern_", "")
    )
    .map(capitalizeWords);

  // Scalp concerns
  const scalpConcern = tags
    .filter(str => str.includes("scalp_concern"))
    .map(str => str.replace("scalp_concern_", ""))
    .map(capitalizeWords);

  // Insert into respective containers
  const hairContainer = document.getElementById("hair_concern_list");
  const scalpContainer = document.getElementById("skin_concern_list");

  // Clear previous content if any
  hairContainer.innerHTML = "";
  scalpContainer.innerHTML = "";

  hairConcern.forEach(item => {
    const iconDiv = document.createElement("div");
    iconDiv.classList.add("selfie_concern_icon");
    iconDiv.innerHTML = `&nbsp;`;
    
    const textDiv = document.createElement("div");
    textDiv.textContent = item;
    
    const concernDiv = document.createElement("div");
    concernDiv.classList.add("selfie_concern_item");
    concernDiv.appendChild(iconDiv);
    concernDiv.appendChild(textDiv);
    
    hairContainer.appendChild(concernDiv);
  });

  scalpConcern.forEach(item => {
    const iconDiv = document.createElement("div");
    iconDiv.classList.add("selfie_concern_icon");
    iconDiv.innerHTML = `&nbsp;`;
    
    const textDiv = document.createElement("div");
    textDiv.textContent = item;

    const concernDiv = document.createElement("div");
    concernDiv.classList.add("selfie_concern_item");
    concernDiv.appendChild(iconDiv);
    concernDiv.appendChild(textDiv);
    
    scalpContainer.appendChild(concernDiv);
  });
}

// Capitalize helper
function capitalizeWords(str) {
  return str.split("_").map(word =>
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(" ");
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => variant.node.id === selectedVariantId).node || productVariants[0];
  }
  
  return productVariants[0].node;
}

function getProductHTML(product, index, variant, section, sections, variantId) {
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant, product);
  const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;
  let variantTitle= variant.title;
  if(variantTitle=="Default Title"){
    variantTitle="";
  }
  let buttonClass="";
  let buttonText = default_addToCartText;
  if(isProductAvailable(product, variant)){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section, variant.price);
  }
  else{
    buttonText = out_of_stock_text;
    buttonClass ="disable-button";
  }

  const rating = getProductRatingValue(product);
  const starRatingDiv = rating > 0 ? getStarRatingHTML(4.4): '';
  const reviewCountDiv = `<div>${product.review_count.value} Reviews</div>`;
  
  // Product View HTML using template literals
  const product_html = `
    <div>
      <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
        <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
        <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
        ${getProductInfo(product)}
        <div class="tangen_review_div">${starRatingDiv}${reviewCountDiv}</div>
        ${getPriceHTML(variant.price)}
      </a>
      <div id="${section}_variant_${index}"></div>
      <p class="tangent-product-add-btn-wrapper tangent-btn-add tangent_add_to_cart_button ${buttonClass}" id="${variantId}">
        ${buttonText}
      </p>
      <div class="tangent-guarantee-text"><img src='https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/36507731169448565-Checkmark.png'/><p class="product_endtext">100% satisfaction guarantee</p></div>
    </div>
  `;
  
  return product_html;
}

function getProductInfo(product){
  return product.productInfo?.value ? `<p class="tangent-product-info-content">${product.productInfo.value}</p>`: '';
}

function getPriceHTML(price){
  const actualPrice = tangent_client_domain_currency + price;
  const discountPrice = tangent_client_domain_currency + applyDiscount(price);
  return `<p class="tangent_product_price_text"><span>${actualPrice}</span>&nbsp;&nbsp;<span class="tangent_current_price">${discountPrice}</span> with code: STARTFRESH20</p>`;
}

function applyDiscount(cost) {
  const discount = cost * 0.20;
  const balance = cost - discount;
  return balance.toFixed(2);
}

function getProductRatingValue(product){
  let rating = 0;

  try {
    const parsed = JSON.parse(product.reviews.value);
    let rawValue = parsed.value;
    // Round down to 4.5 if the value is close to 5 (e.g., 4.75 or higher)
    if (rawValue >= 4.5) {
      rating = 4.5;
    } else {
      rating = rawValue;
    }
    return rating;
  
  } catch (e) {
    console.warn('Invalid review data:', e);
    return rating;
  }
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

function setTabOpen(tags) {
    // Show the tab wrapper
    document.querySelector("#tab-wrapper").style.display = "block";

    // Hide all tab contents and deactivate all tab links first
    const tabContents = document.querySelectorAll(".tabcontent");
    const tabLinks = document.querySelectorAll(".tablinks");
    tabContents.forEach(content => content.style.display = "none");
    tabLinks.forEach(link => link.classList.remove("active"));

    // Determine which tab to show
    let tabIndex = 2; // Default to 3rd tab
    // if (tags.includes("routine_5_mins")) {
    //     tabIndex = 0;
    // } else if (tags.includes("routine_10_mins")) {
    //     tabIndex = 1;
    // }

    if (tabContents[tabIndex]) tabContents[tabIndex].style.display = "block";
    // if (tabLinks[tabIndex]) tabLinks[tabIndex].classList.add("active");
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid,section_name, price) {
    if (!product_sections) return;
  
    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: [],
                    total: 0
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);
                sectionData.total = sectionData.total + Number(price);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}_add_all_to_cart`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "flex" : "none";
                }
                const sectionTotal = document.getElementById(`${section}_amount`);
                if(sectionTotal){
                  sectionTotal.innerHTML = tangent_client_domain_currency + sectionData.total + "&nbsp;&nbsp;<span class='section_amount_value'>"+ tangent_client_domain_currency + applyDiscount(sectionData.total)+"</span>";
                }
            }
        }
    }
}

// Add all to cart function for sections
function addAllTocartFunction(section) {  
  if(sections_add_to_cart_map[section]!=undefined){
    tangentAddAllToCartApi(sections_add_to_cart_map[section].list);
  } 
  else {
    var x = document.querySelector("#message-text");
    x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
    x.className = "show";
    setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';

  if (variant?.image?.url) {
    return variant.image.url;
  }

  if (product?.images?.nodes?.length > 0 && product.images.nodes[0].url) {
    return product.images.nodes[0].url;
  }

  return fallbackImage;
};

function getStarRatingHTML(rating) {
  const clampedRating = Math.min(Math.max(rating, 0), 5);
  const percentage = (clampedRating / 5) * 100;

  return `
<div class="star-rating">
  <div class="stars" style="--rating: ${percentage}%;">&nbsp;</div>
</div>
`;
}



// Add To Cart Function
function tangentAddToCart(btn) {
  if (!btn || !btn.id) return;

  const items = [{ id: btn.id, quantity: 1 }];

  addItemsToCart(
    items,
    () => {
      btn.innerHTML = typeof default_addedToCartText !== 'undefined' ? default_addedToCartText : "Added to Cart";
      btn.classList.add("added-to-cart-style");
      showCartDrawer();
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    },
    () => {
      showSnackbar("Failed to add item to cart.");
    }
  );
}

function tangentAddAllToCartApi(list) {
  const items = list.map(id => ({ id, quantity: 1 }));

  addItemsToCart(
    items,
    (data) => {
      console.log("Successfully added items to cart:", data);
      showCartDrawer();
      showSnackbar("All items added to cart!");
    },
    () => {
      showSnackbar("Failed to add items to cart.");
    }
  );
}


// Shared logic to add items to cart
function addItemsToCart(items, onSuccess = () => {}, onError = () => {}) {
  if (!Array.isArray(items) || items.length === 0) {
    onError("No items to add.");
    return;
  }

  const formData = { items };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    onSuccess(data);
  })
  .catch(error => {
    console.error("Add to cart failed:", error);
    onError(error);
  });
}


function showCartDrawer(){
  if (typeof sideCart !== 'undefined') {
      sideCart.reloadCart();
      sideCart.openCart();    
  }
}

function showSnackbar(message = "Items added to cart!") {
  const snackbar = document.getElementById("snackbar");
  snackbar.textContent = message;
  snackbar.classList.add("show");

  setTimeout(() => {
    snackbar.classList.remove("show");
  }, 3000); // Hide after 3 seconds
}

// Main Section container 
function createSectionContainer(section_name){
  var section_container = document.createElement("div");
  section_container.id=section_name+"_container";

  if(section_name!="section_additional_products" && section_name!="section_purpose"){
      section_container.classList.add("tabcontent");
  }
  return section_container;
}

function createSectionAddAllToCart(section_name) {
  const button = document.createElement("button");
  button.id = `${section_name}_add_all_to_cart`;
  button.classList.add("section_add_all_to_cart","section_add_all_cart_link", `${section_name}_add_all_to_cart`);
  button.setAttribute("aria-label", `Add all items in ${section_name} to cart`);
  button.type = "button";

  // Icon image
  const icon = document.createElement("img");
  icon.src = "https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/3597189140030759-shopping-bag.png";
  icon.alt = "Add Icon";
  icon.classList.add("add-all-icon");
  icon.style.width = "16px";  // Adjust size if needed
  icon.style.height = "16px";

  // Text inside a span
  const textSpan = document.createElement("span");
  textSpan.textContent = default_add_all_to_cart_text;
  textSpan.classList.add("add-all-text");

  // Assemble the button
  button.appendChild(icon);
  button.appendChild(textSpan);

  // Click event
  button.addEventListener("click", function (e) {
    e.preventDefault();
    addAllTocartFunction(section_name);
  });

  return button;
}



// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    if(section_name!="section_additional_products"){
      var tab_button = document.createElement("button");
      tab_button.id = section_name+"_tab_button";
      tab_button.innerHTML = getTabTitle(section_name);
      tab_button.name = section_name;
      tab_button.classList.add("tablinks");
      tab_button.addEventListener(
          'click',
          function () { switchTab(this); },
          false
      );
      tangent_custom_tabs.appendChild(tab_button);
    }
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));

    
      section_container.appendChild(createTotalAmountText(section_name));

      const button_container = createDiv({id:section_name+'_button_container', className:"sections_button_container"});
      button_container.appendChild(createSectionAddAllToCart(section_name));
      button_container.appendChild(createEmailButton(section_name));
      section_container.appendChild(button_container);
      
      if(section_name == "section_additional_products"){
        var section_additional = document.querySelector("#section_additional_parent_container");
        section_container.classList.remove('tabcontent');   
        section_additional.appendChild(section_container);
      }
      else{
        // Add to main container wrapper
        tangent_sections_wrapper_element.appendChild(section_container);
        // createTabButton(section_name);
      }
    }
}

function createDiv({ id = '', className = '', text = '', styles = {} } = {}) {
  const div = document.createElement('div');

  if (id) div.id = id;
  if (className) div.className = className;
  if (text) div.textContent = text;

  // Apply inline styles if provided
  for (let key in styles) {
    div.style[key] = styles[key];
  }

  return div;
}


function createEmailButton(section) {
  // Create button
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'tangent_email_button';
  button.style.position = 'relative';

  // Add label text
  const labelNode = document.createTextNode("Email My Routine");
  button.appendChild(labelNode);

  // Add icon image
  const icon = document.createElement('img');
  icon.src = "https://file.tangent.ai/quiz-content/merchants/no-nothing-very-sensitive/image/7262957787807944-Group%2047408.png";
  icon.alt = 'Email icon';
  icon.className = 'icon';
  button.appendChild(icon);
  return button;
}

function createEmailPopup(){
   // Create popup div
  const popup = document.createElement('div');
  popup.className = 'popup';

  // Popup message paragraph
  const p = document.createElement('p');
  p.textContent = 'Your routine has been mailed to your email address.';
  popup.appendChild(p);

  // Popup close button
  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'close-btn';
  closeBtn.textContent = 'Close';
  popup.appendChild(closeBtn);

  document.getElementById("tangent-recommendation-banner-section").appendChild(popup);
}

function createTotalAmountText(section_name){
  let total_amount_text = document.createElement("p");
  total_amount_text.id = section_name + "_amount_text";
  total_amount_text.classList.add("section_amount_text", section_name + "_amount_text");

  const total_cost = document.createElement("span");
  total_cost.id = section_name + "_amount";
  total_cost.classList.add(section_name + "_amount_value");
  
  const amount_static_text = document.createElement("span");
  amount_static_text.id = section_name + "_static_text";
  amount_static_text.classList.add("section_amount_static_text", section_name + "_amount_static_text");
  amount_static_text.innerHTML = ` with code: <b>STARTFRESH20</b>`;
  
  total_amount_text.appendChild(total_cost);
  total_amount_text.appendChild(amount_static_text);
  return total_amount_text;
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_selfie.appendChild(section_container);
            }
            else if(section_name == "section_additional_products"){
              var section_additional = document.querySelector("#section_additional_parent_container");
              section_container.classList.remove('tabcontent');   
              section_additional.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}

// Enabling button listeners
function enableButtonListener(){
  // Listner for section add all to carts
  var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
  for (var b = 0; b < all_btns.length; b++) {
      all_btns[b].addEventListener(
          'click',
          function () { tangentAddToCart(this); },
          false
      );
  }
  createEmailPopup();
  
  const emailButtons = document.querySelectorAll('.tangent_email_button');

  emailButtons.forEach(button => {
    button.addEventListener(
        'click',
        function () { showSnackbar("Your Routine has been mailed to your Email Address"); },
        false
    );
  });

}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}
